function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 44.5V49H40.5V44.5L44.5 37.5V19L27 13.5L26.5 3L23 1L19.5 4V22H17L13.5 25.5V37.5L19.5 44.5Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3625 13.6231L44.9712 18.768V37.3912L40.1886 44.6376V48.9129",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3189 48.9128V44.6374L13.087 37.3911",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6813 28.4058V4.71019C19.6813 2.68121 21.2755 1.08701 23.3045 1.08701C25.3334 1.08701 26.9277 2.68121 26.9277 4.71019V21.9566",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.942 15.2174V23.6957",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9567 25.5073V17.029",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.087 37.3912V27.3187C13.087 24.3477 15.4783 21.9564 18.4494 21.9564H19.6812",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("mask", {
  id: "path-9-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.3508 11.485L55.3511 11.4853L56.932 9.9044L49.0276 2L47.4467 3.58088L52.4966 8.63079L42 8.63079V10.6308L53.0433 10.6308L47.4464 16.2277L49.0272 17.8086L55.3508 11.485Z"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.3508 11.485L55.3511 11.4853L56.932 9.9044L49.0276 2L47.4467 3.58088L52.4966 8.63079L42 8.63079V10.6308L53.0433 10.6308L47.4464 16.2277L49.0272 17.8086L55.3508 11.485Z",
  fill: "#6C8936"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M55.3511 11.4853L54.644 12.1924L55.3511 12.8995L56.0582 12.1924L55.3511 11.4853ZM55.3508 11.485L56.0579 10.7779L55.3508 10.0708L54.6437 10.7779L55.3508 11.485ZM56.932 9.9044L57.6391 10.6115L58.3462 9.9044L57.6391 9.1973L56.932 9.9044ZM49.0276 2L49.7347 1.29289L49.0276 0.585786L48.3204 1.29289L49.0276 2ZM47.4467 3.58088L46.7396 2.87377L46.0325 3.58088L46.7396 4.28799L47.4467 3.58088ZM52.4966 8.63079V9.63079H54.9108L53.2037 7.92368L52.4966 8.63079ZM42 8.63079L42 7.63079H41V8.63079H42ZM42 10.6308H41V11.6308H42L42 10.6308ZM53.0433 10.6308L53.7504 11.3379L55.4575 9.63079H53.0433V10.6308ZM47.4464 16.2277L46.7393 15.5206L46.0321 16.2277L46.7393 16.9349L47.4464 16.2277ZM49.0272 17.8086L48.3201 18.5157L49.0272 19.2228L49.7343 18.5157L49.0272 17.8086ZM56.0582 10.7782L56.0579 10.7779L54.6437 12.1921L54.644 12.1924L56.0582 10.7782ZM56.2248 9.1973L54.644 10.7782L56.0582 12.1924L57.6391 10.6115L56.2248 9.1973ZM48.3204 2.70711L56.2248 10.6115L57.6391 9.1973L49.7347 1.29289L48.3204 2.70711ZM48.1538 4.28799L49.7347 2.70711L48.3204 1.29289L46.7396 2.87377L48.1538 4.28799ZM53.2037 7.92368L48.1538 2.87377L46.7396 4.28799L51.7895 9.3379L53.2037 7.92368ZM52.4966 7.63079L42 7.63079L42 9.63079L52.4966 9.63079V7.63079ZM41 8.63079V10.6308H43V8.63079H41ZM42 11.6308L53.0433 11.6308V9.63079L42 9.63079L42 11.6308ZM52.3362 9.92368L46.7393 15.5206L48.1535 16.9349L53.7504 11.3379L52.3362 9.92368ZM46.7393 16.9349L48.3201 18.5157L49.7343 17.1015L48.1535 15.5206L46.7393 16.9349ZM49.7343 18.5157L56.0579 12.1921L54.6437 10.7779L48.3201 17.1015L49.7343 18.5157Z",
  fill: "#6C8936",
  mask: "url(#path-9-inside-1)"
});

var _ref12 = /*#__PURE__*/React.createElement("mask", {
  id: "path-11-inside-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5813 11.485L1.58105 11.4853L0.000174522 9.9044L7.90457 2L9.48545 3.58088L4.43554 8.63079L14.9321 8.63079V10.6308L3.88881 10.6308L9.48577 16.2277L7.90489 17.8086L1.5813 11.485Z"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5813 11.485L1.58105 11.4853L0.000174522 9.9044L7.90457 2L9.48545 3.58088L4.43554 8.63079L14.9321 8.63079V10.6308L3.88881 10.6308L9.48577 16.2277L7.90489 17.8086L1.5813 11.485Z",
  fill: "#6C8936"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1.58105 11.4853L2.28816 12.1924L1.58105 12.8995L0.873948 12.1924L1.58105 11.4853ZM1.5813 11.485L0.874192 10.7779L1.5813 10.0708L2.28841 10.7779L1.5813 11.485ZM0.000174522 9.9044L-0.706932 10.6115L-1.41404 9.9044L-0.706932 9.1973L0.000174522 9.9044ZM7.90457 2L7.19747 1.29289L7.90457 0.585786L8.61168 1.29289L7.90457 2ZM9.48545 3.58088L10.1926 2.87377L10.8997 3.58088L10.1926 4.28799L9.48545 3.58088ZM4.43554 8.63079V9.63079H2.02133L3.72844 7.92368L4.43554 8.63079ZM14.9321 8.63079L14.9321 7.63079H15.9321V8.63079H14.9321ZM14.9321 10.6308H15.9321V11.6308H14.9321L14.9321 10.6308ZM3.88881 10.6308L3.18171 11.3379L1.4746 9.63079H3.88881V10.6308ZM9.48577 16.2277L10.1929 15.5206L10.9 16.2277L10.1929 16.9349L9.48577 16.2277ZM7.90489 17.8086L8.612 18.5157L7.90489 19.2228L7.19778 18.5157L7.90489 17.8086ZM0.873948 10.7782L0.874192 10.7779L2.28841 12.1921L2.28816 12.1924L0.873948 10.7782ZM0.707281 9.1973L2.28816 10.7782L0.873948 12.1924L-0.706932 10.6115L0.707281 9.1973ZM8.61168 2.70711L0.707281 10.6115L-0.706932 9.1973L7.19747 1.29289L8.61168 2.70711ZM8.77835 4.28799L7.19747 2.70711L8.61168 1.29289L10.1926 2.87377L8.77835 4.28799ZM3.72844 7.92368L8.77835 2.87377L10.1926 4.28799L5.14265 9.3379L3.72844 7.92368ZM4.43554 7.63079L14.9321 7.63079L14.9321 9.63079L4.43554 9.63079V7.63079ZM15.9321 8.63079V10.6308H13.9321V8.63079H15.9321ZM14.9321 11.6308L3.88881 11.6308V9.63079L14.9321 9.63079L14.9321 11.6308ZM4.59592 9.92368L10.1929 15.5206L8.77866 16.9349L3.18171 11.3379L4.59592 9.92368ZM10.1929 16.9349L8.612 18.5157L7.19778 17.1015L8.77866 15.5206L10.1929 16.9349ZM7.19778 18.5157L0.874192 12.1921L2.28841 10.7779L8.612 17.1015L7.19778 18.5157Z",
  fill: "#6C8936",
  mask: "url(#path-11-inside-2)"
});

function SvgTouchControlExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchControlExplore);
export default __webpack_public_path__ + "static/media/touch-control-explore.b52d7eaa.svg";
export { ForwardRef as ReactComponent };